




import { Component, Vue } from 'vue-property-decorator'

@Component
export default class BreadcrumbsComponent extends Vue {
  items() {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)){
      /* メタデータを使用する */
      return this.$route.meta.breadcrumbs
    } else {
      return null
    }
  }
}
